import { ResponseParams, ApiError, requestHttpGet, requestHttpPost, requestHttpPut } from './RequestBase';

export type User = {
	gidpk: string;
	gid: string;
	mailaddress_1: string;
	mailaddress_2: string;
	mailaddress_3: string;
	mobile: string;
	lastname: string;
	firstname: string;
	kana_lastname: string;
	kana_firstname: string;
	birth: string;
	nickname: string;
	sex: number; // 0:男, 1:女
	country: string;
	zip: string;
	tel: string;
	tel_2: string;
	pref_cd: string;
	address_2: string;
	address_3: string;
	address_4: string;
	address_5: string;
	address_6: string;
	family_cd: number;
	family_type: number;
	directmail_flg: number;
	payment_not_flg: number;
	withdrawal_flg: string;
	agree_flg: number;
	data_util_agree_flg: number;
	retrys: string;
	regist_ts: string;
	update_ts: string;
	pass_update_ts: string;
	withdrawal_ts: string;
	ext_1: string;
	ext_2: string;
	ext_3: string;
	member_flg: number;
	cookie_id?: string;
	last_agree_version?: string;
	latest_terms_version?: string;
	latest_terms_agree_flg?: number;
};

export const initialUserData = {
	gidpk: '',
	gid: '',
	mailaddress_1: '',
	mailaddress_2: '',
	mailaddress_3: '',
	mobile: '',
	lastname: '',
	firstname: '',
	kana_lastname: '',
	kana_firstname: '',
	birth: undefined,
	nickname: '',
	sex: 0,
	country: 'JPN',
	zip: '',
	tel: '',
	pref_cd: '01',
	address_2: '',
	address_3: '',
	address_4: '',
	address_5: '',
	address_6: '',
	family_cd: 0,
	family_type: 0,
	directmail_flg: 1,
	payment_not_flg: 0,
	retrys: '',
	withdrawal_flg: '',
	agree_flg: 0,
	regist_ts: '',
	update_ts: '',
	pass_update_ts: '',
	withdrawal_ts: '',
	tel_2: '',
	ext_1: '',
	ext_2: '',
	ext_3: '',
	data_util_agree_flg: 1,
	member_flg: 0,
};

export type UserWithPass = User & {
	pass: string;
};

// 個人情報取得
export const callGetUserApi = async (): Promise<ResponseParams<User>> => {
	const result: ResponseParams<User> = await requestHttpGet(`/users`);
	return result;
};

export type CreateUser = {
	mailaddress_1: string;
	gid: string;
	pass: string;
	lastname: string;
	firstname: string;
	kana_lastname: string;
	kana_firstname: string;
	birth: string;
	sex: number;
	directmail_flg: number;
	data_util_agree_flg: number;
	tel: string;
	zip: string;
	pref_cd: string;
	address_2: string;
	address_3: string;
	address_4: string;
	nickname: string;
	country: string;
	family_type: number;
	agree_flg: number;
	update_site_cd?: string;
};
export type CreateUsersReqData = {
	user_list: CreateUser[];
};
type CreateUsersResData = {
	user_list: User[];
};
// 個人情報登録（バルク）
export const callCreateUsersApi = async (body: CreateUsersReqData): Promise<ResponseParams<CreateUsersResData>> => {
	const result: ResponseParams<CreateUsersResData> = await requestHttpPost(`/users/bulk`, body);
	return result;
};

// isGidChange: バックエンドでGIDが変更されたか判定が必要なため
export type UpdateUserReqData = {
	isGidChange: boolean;
	data: {
		gid?: string;
		mailaddress_1?: string;
		lastname?: string;
		firstname?: string;
		kana_lastname?: string;
		kana_firstname?: string;
		birth?: string;
		nickname?: string;
		sex?: number;
		country?: string;
		zip?: string;
		tel?: string;
		pref_cd?: string;
		address_2?: string;
		address_3?: string;
		address_4?: string;
		family_type?: number;
		directmail_flg?: number;
		agree_flg?: number;
		data_util_agree_flg?: number;
	};
};
// 個人情報更新
export const callUpdateUserApi = async (body: UpdateUserReqData): Promise<ResponseParams<User>> => {
	const result: ResponseParams<User> = await requestHttpPut(`/users`, body);
	return result;
};

export type UpdateUser = {
	gidpk: string;
	pass?: string;
	gid?: string;
	mailaddress_1?: string;
	mailaddress_2?: string;
	mailaddress_3?: string;
	mobile?: string;
	lastname?: string;
	firstname?: string;
	kana_lastname?: string;
	kana_firstname?: string;
	birth?: string;
	nickname?: string;
	sex?: number; // 0:男, 1:女
	country?: string;
	zip?: string;
	tel?: string;
	tel_2?: string;
	pref_cd?: string;
	address_2?: string;
	address_3?: string;
	address_4?: string;
	address_5?: string;
	address_6?: string;
	family_cd?: number;
	family_type?: number;
	directmail_flg?: number;
	payment_not_flg?: number;
	retrys?: string;
	withdrawal_flg?: string;
	agree_flg?: number;
	ext_1?: string;
	ext_2?: string;
	ext_3?: string;
	data_util_agree_flg?: number;
	withdrawal_ts?: string;
};
type UpdateUsersBulkReqData = {
	user_list: UpdateUser[];
};
type UpdateUsersBulkResData = {
	user_list: User[];
};
// 個人情報更新（バルク）
export const callUpdateUserBulkApi = async (
	body: UpdateUsersBulkReqData,
): Promise<ResponseParams<UpdateUsersBulkResData>> => {
	const result: ResponseParams<UpdateUsersBulkResData> = await requestHttpPut(`/users/bulk`, body);
	return result;
};

type SearchUsersReqData = {
	gidpk?: string;
	gid?: string;
	mailaddress_1?: string;
	mobile?: string;
	lastname?: string;
	firstname?: string;
	kana_lastname?: string;
	kana_firstname?: string;
	birth?: string;
	nickname?: string;
	sex?: number; // 0:男, 1:女
	country?: string;
	zip?: string;
	tel?: string;
	pref_cd?: string;
	address_1?: string;
	address_2?: string;
	address_3?: string;
	address_4?: string;
	address_5?: string;
	address_6?: string;
	family_cd?: number;
	family_type?: number;
	directmail_flg?: number;
	payment_not_flg?: number;
	retrys?: string;
	withdrawal_flg?: number;
	agree_flg?: number;
	withdrawal_ts?: string;
	ext_1?: string;
	ext_2?: string;
	ext_3?: string;
	data_util_agree_flg?: number;
	offset?: number;
	limit?: number;
};
type SearchUsersResData = {
	user_list: User[];
};
export const callSearchUsersApi = async (body: SearchUsersReqData): Promise<ResponseParams<SearchUsersResData>> => {
	const result: ResponseParams<SearchUsersResData> = await requestHttpPost(`/users/search`, body);
	return result;
};

export type UpdateUserPasswordReqData = {
	gidpk: string;
	old_pw: string;
	new_pw: string;
};
// パスワード変更（会員）
export const callUpdateUserPasswordApi = async (
	body: UpdateUserPasswordReqData,
): Promise<ResponseParams<void | ApiError>> => {
	const result: ResponseParams<any> = await requestHttpPut(`/users/password`, body);
	return result;
};

type CheckMailAddressReqData = {
	mailaddress: string;
};
type CheckMailAddressResData = {
	exist: boolean;
};
// メールアドレス重複確認
export const callCheckMailAddressDuplicateApi = async (
	query: CheckMailAddressReqData,
): Promise<ResponseParams<CheckMailAddressResData>> => {
	const result: ResponseParams<CheckMailAddressResData> = await requestHttpGet(`/users/duplicate/mailaddress`, {
		mailaddress: encodeURIComponent(query.mailaddress),
	});
	return result;
};

export type CheckGakkenIdReqData = {
	gid: string;
};
type CheckGakkenIdResData = {
	exist: boolean;
};
// 学研ID重複確認
export const callCheckGakkenIdDuplicateApi = async (
	query: CheckGakkenIdReqData,
): Promise<ResponseParams<CheckGakkenIdResData>> => {
	const result: ResponseParams<CheckGakkenIdResData> = await requestHttpGet(`/users/duplicate/gid`, {
		gid: encodeURIComponent(query.gid),
	});
	return result;
};

type SendOnetimePasswordMailReqData = {
	mailaddress: string;
	send_type: number; // 1:仮登録, 2:メールアドレス変更, 3:パスワード忘れ, 4:代表者変更
};
// 仮登録メール送信
export const callSendOnetimePasswordMailApi = async (
	body: SendOnetimePasswordMailReqData,
): Promise<ResponseParams<void>> => {
	const result: ResponseParams<void> = await requestHttpPost(`/onetimepass`, body);
	return result;
};

type CheckOnetimePasswordReqData = {
	mailaddress: string;
	onetimepass: string;
};
export type CheckOnetimePasswordResData = {
	exist: boolean;
	gid: string;
};
// ワンタイムパスワード検証
export const callCheckOnetimePasswordApi = async (
	body: CheckOnetimePasswordReqData,
): Promise<ResponseParams<CheckOnetimePasswordResData | ApiError>> => {
	const result: ResponseParams<CheckOnetimePasswordResData | ApiError> = await requestHttpPost(
		`/onetimepass/check`,
		body,
	);
	return result;
};

// 規約同意更新
export const callAgreeApi = async (): Promise<ResponseParams<void>> => {
	const result: ResponseParams<void> = await requestHttpPost(`/agree`, {});
	return result;
};

type SendMailReqData = {
	send_type: number; // 1:登録完了 2:退会
};
// メール送信
export const callSendMailApi = async (body: SendMailReqData): Promise<ResponseParams<void>> => {
	const result: ResponseParams<void> = await requestHttpPost(`messages/send`, body);
	return result;
};

export type ForgotIdReqData = {
	lastname: string;
	firstname: string;
	mailaddress: string;
};
// GID存在確認
export const callForgotIdApi = async (body: ForgotIdReqData): Promise<ResponseParams<void | ApiError>> => {
	const result: ResponseParams<void | ApiError> = await requestHttpPost(`/gids/existence`, body);
	return result;
};

// 契約中サービス取得
type GetServiceAgreementReqData = {
	gidpklist: string; // gidpkをカンマ区切りで複数指定可能
};
export type GetServiceAgreementResData = {
	gid_list: ServiceAgreementGid[];
};
type ServiceAgreementGid = {
	gidpk: string;
	service_agreement_list: ServiceAgreement[];
};
export type ServiceAgreement = {
	site_cd: string;
	display_site_name: string;
	setting_change_url: string;
	withdrawal_lock: number;
	regist_ts: string;
	update_ts: string;
};
export const callGetServiceAgreementApi = async (
	req: GetServiceAgreementReqData,
): Promise<ResponseParams<GetServiceAgreementResData | ApiError>> => {
	const result: ResponseParams<GetServiceAgreementResData | ApiError> = await requestHttpGet(
		`/users/service/agreement`,
		req,
	);
	return result;
};

// 退会理由一覧取得
export type GetWithdrawalReasonResData = {
	withdrawal_reason_list: WithdrawalReason[];
};
export type WithdrawalReason = {
	withdrawal_reason_cd: string;
	withdrawal_reason_label: string;
	withdrawal_reason_display_order: number;
};

export const callGetQuestionApi = async (): Promise<ResponseParams<GetWithdrawalReasonResData | ApiError>> => {
	const result: ResponseParams<GetWithdrawalReasonResData | ApiError> = await requestHttpGet(`/withdrawal-reasons`, {});
	return result;
};

// 会員退会
type WithdrawalReasonReqData = {
	withdrawal_reason_cd_list: { withdrawal_reason_cd: string }[];
	withdrawal_reason_detail: string;
};
export const callWithdrawalReasonApi = async (
	body: WithdrawalReasonReqData,
): Promise<ResponseParams<void | ApiError>> => {
	const result: ResponseParams<void | ApiError> = await requestHttpPost(`/users/withdrawal-reason`, body);
	return result;
};

// 会員退会用家族情報取得
type GetIsLockReqData = {
	gidpk: string;
};
export const initialIsLockData: GetIsLockResData = {
	is_representative: false,
	is_lock: false,
	member_exist: false,
};
export type GetIsLockResData = {
	is_representative: boolean;
	is_lock: boolean;
	member_exist: boolean;
};
export const callGetIsLockApi = async (
	req?: GetIsLockReqData,
): Promise<ResponseParams<GetIsLockResData | ApiError>> => {
	const result: ResponseParams<GetIsLockResData | ApiError> = await requestHttpGet(`/users/family/withdrawal`, req);
	return result;
};

// 属性提供フラグ登録
export const callAttributeAgreeApi = async (siteCd: string, scope?: string): Promise<ResponseParams<void>> => {
	const result: ResponseParams<void> = await requestHttpPost(`/claim-agreements`, { siteCd, scope });
	return result;
};

// 会員退会不可サービス利用情報取得
type GetServiceProhibitionReqData = {
	gidpk: string;
};
export type GetServiceProhibitionResData = {
	use_prohibited_service: boolean;
};
export const callGetServiceProhibitionApi = async (
	req?: GetServiceProhibitionReqData,
): Promise<ResponseParams<GetServiceProhibitionResData | ApiError>> => {
	const result: ResponseParams<GetServiceProhibitionResData | ApiError> = await requestHttpGet(
		`/users/services/prohibition`,
		req,
	);
	return result;
};

export type GetAttributeAgreeResData = {
	site_cd: string;
	claim_agreement_flg: boolean;
	disagreement_scope: string;
};
// 属性提供フラグ取得
export const callGetAttributeAgreeApi = async (
	siteCd: string,
	scope?: string,
): Promise<ResponseParams<GetAttributeAgreeResData>> => {
	const result: ResponseParams<GetAttributeAgreeResData> = await requestHttpGet(`/claim-agreements`, {
		siteCd: encodeURIComponent(siteCd),
		scope: encodeURIComponent(scope),
	});
	return result;
};
type GetUsersDisplayItemReqData = {
	gidpk: string;
};
/*
 * 1：表示＆必須入力
 * 2：表示＆任意入力
 * 3：非表示
 * 0：未使用（エラー）
 */
export type UsersDisplayItems = {
	gid: number;
	pass: number;
	mailaddress_1: number;
	mailaddress_2: number;
	mailaddress_3: number;
	mobile: number;
	lastname: number;
	firstname: number;
	kana_lastname: number;
	kana_firstname: number;
	birth: number;
	nickname: number;
	sex: number;
	country: number;
	zip: number;
	tel: number;
	pref_cd: number;
	address_2: number;
	address_3: number;
	address_4: number;
	address_5: number;
	address_6: number;
	family_cd: number;
	family_type: number;
	directmail_flg: number;
	payment_not_flg: number;
	withdrawal_flg: number;
	regist_ts: number;
	update_ts: number;
	tel_2: number;
	ext_1: number;
	ext_2: number;
	ext_3: number;
	data_util_agree_flg: number;
};
// ユーザー別表示項目取得
export const callGetUsersSiteDisplayItemsApi = async (
	req?: GetUsersDisplayItemReqData,
): Promise<ResponseParams<UsersDisplayItems>> => {
	const result: ResponseParams<UsersDisplayItems> = await requestHttpGet(`/users/sites/display-item`, req);
	return result;
};
